"use client";
export { RichText as default } from "../../../_Builtin/Typography";
